import { render, staticRenderFns } from "./ShelvingSVG.vue?vue&type=template&id=d8501a1c&"
import script from "./ShelvingSVG.vue?vue&type=script&lang=js&"
export * from "./ShelvingSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports